import styled from 'styled-components';

import Spinner from 'react-spinners/ClipLoader';

interface ContainerProps {
  color?: string;
}

export const Container = styled.button<ContainerProps>`
  width: fit-content;
  height: fit-content;
  padding: 5px;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  background-color: ${(props) => props.color ?? props.theme.colors.primary};
  color: ${(props) => props.theme.colors.white};
  display: flex;
  align-items: center;
  gap: 5px;
  transition: 0.2s;

  &:hover {
    transform: scale(1.2);
  }

  &:active {
    transform: scale(0.8);
  }
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Loading = styled(Spinner).attrs((props) => ({
  size: 16,
  color: props.theme.colors.white,
}))``;
